// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Eq_0Y","content":"styles_content__1Jpnt","checkbox":"styles_checkbox__lUg7Y","checkboxLabel":"styles_checkboxLabel__26w3F"};